export default "__VITE_ASSET__e4b6f029__"